<template>
    <!--   </v-container>-->
    <v-sheet style="background-color:#fafafa;height:100%">
        <v-card>
            <v-card-title>
            Produtos
            <div class="flex-grow-1"></div>
            <v-text-field
                v-model="search"
                append-icon="search"
                label="Buscar produtos"
                single-line
                hide-details
            ></v-text-field>
            </v-card-title>
            <v-data-table
            :headers="headers"
            :items="products"
            :search="search"
            >
             <template v-slot:item.artist="{item}">                
                <span v-if="item.artist">{{item.artist.name}}</span>

            </template>

            <template v-slot:item.cover="{item}">                
                <v-img
                    width="70px"
                    v-if="item.thumbnail"
                    :src="get_cover_url(item)"
                />
            </template>
            
            </v-data-table>
        </v-card>
        

    </v-sheet>
</template>

<script>
import ProductService from "../../../app/rest/products"

var productService = null;

export default {
    components:{ },
    data: () => ({
        search: '',
        products:[],
        now: '2019-09-01',
        events: [],
        headers: [
          {
            text: 'Capa',
            align: 'left',
            sortable: false,
            value: 'cover',
          },
          { text: 'Nome', value: 'name' },
          { text: 'Artista principal', value: 'artist' },
          { text: 'UPC', value: 'upc' },         
          { text: 'Data de lançamento', value: 'release_date' },
          { text: 'Status', value: 'status' }          
        ],
    }),
    beforeCreate:function(){
        productService = ProductService.build();
        productService.get_all({flavor:'audio',status:'draft'}).then( e =>{
            if(e.status=="ok"){
                this.products = e.items.products;
                this.events = e.items.products.map( (e,i)=>{
                    var x = {};
                    x.name = e.name;
                    x.start = e.release_date;
                    return x;
                });
                console.log("eventos", this.events);
            }

        }).catch( e =>{
            console.log(e);
        }).finally( () =>{
            
        });
    },
    methods:{
        get_cover_url(item){
            return process.env.VUE_APP_BASE_URL + item.thumbnail;
        }
    }
};
</script>